import { Grid, Typography } from '@mui/material';
import React from 'react';
import { getSubTextValues } from './helper';
import { useTranslation } from 'react-i18next';
import { IPlacementMarginOverTimeHourlyRateItem } from 'store/redux-store/margin-tool/slices/placement/placement-add-edit-scenario/add-edit-placement-scenario.model';
import { PreviewContainerFieldNames } from '../enum';
import { formatNumber } from '../helper';

const PayPackageSubText = ({
  fieldName,
  currSplitRates,
  fieldValue,
  eachSplit,
  customClass,
}: {
  fieldName: string;
  fieldValue: number | string;
  customClass: Record<string, string>;
  eachSplit: any;
  currSplitRates: IPlacementMarginOverTimeHourlyRateItem;
}) => {
  const { t } = useTranslation();

  const subTextValues = getSubTextValues({
    fieldName,
    currSplitRates,
    fieldValue,
  });

  const onCallRate =
    Number(eachSplit[PreviewContainerFieldNames.onCallRate]) > 0
      ? parseFloat(eachSplit[PreviewContainerFieldNames.onCallRate])
      : null;

  const callBackRate =
    fieldName === PreviewContainerFieldNames.payRate &&
    Number(eachSplit[PreviewContainerFieldNames.payCallBackFactor]) > 0
      ? (1 + Number(eachSplit[PreviewContainerFieldNames.payCallBackFactor])) * Number(fieldValue)
      : null;

  const mileage =
    fieldName === PreviewContainerFieldNames.payRate &&
    Number(eachSplit[PreviewContainerFieldNames.payAmountPerMile]) > 0
      ? parseFloat(eachSplit[PreviewContainerFieldNames.payAmountPerMile])
      : null;

  return (
    <Grid container>
      <Grid item xs={12} className={customClass.subTextContainer}>
        {fieldName === PreviewContainerFieldNames.payRate ? (
          <>
            {onCallRate && onCallRate > 0 && (
              <Typography variant="body2">
                <span className={customClass.subTextLabel}>{t('marginTool.payPackagePreview.onCallRate')}</span>{' '}
                {t('marginTool.payPackagePreview.onCallRateSubText', {
                  onCallRate: formatNumber(onCallRate, 2) || 0,
                })}
              </Typography>
            )}
            {callBackRate && callBackRate > 0 && (
              <Typography variant="body2">
                <span className={customClass.subTextLabel}>{t('marginTool.payPackagePreview.callBackRate')}</span>{' '}
                {t('marginTool.payPackagePreview.onCallBackRateSubText', {
                  callBackRate: formatNumber(callBackRate, 2) || 0,
                })}
              </Typography>
            )}
            {mileage && mileage > 0 && (
              <Typography variant="body2">
                <span className={customClass.subTextLabel}>{t('marginTool.payPackagePreview.mileage')}</span>{' '}
                {t('marginTool.payPackagePreview.mileageSubText', {
                  mileage: formatNumber(mileage, 3) || 0,
                })}
              </Typography>
            )}
          </>
        ) : (
          <>
            {subTextValues?.enableDaily && (
              <Typography variant="body2">
                <span className={customClass.subTextLabel}>{t('marginTool.payPackagePreview.daily')}</span>{' '}
                {t('marginTool.payPackagePreview.daySubText', {
                  dailyValue: formatNumber(subTextValues?.dailyValue || 0, 2),
                  dailyHours: formatNumber(subTextValues?.dailyHours || 0, 2),
                })}
              </Typography>
            )}
            {subTextValues?.enableWeekly && (
              <Typography variant="body2">
                <span className={customClass.subTextLabel}>{t('marginTool.payPackagePreview.weekly')}</span>{' '}
                {t('marginTool.payPackagePreview.weekSubText', {
                  weeklyValue: formatNumber(subTextValues?.weeklyValue || 0, 2),
                  weeklyHours: formatNumber(subTextValues?.weeklyHours || 0, 2),
                })}
              </Typography>
            )}
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default PayPackageSubText;
